@for (radioNode of radioNodeMap | keyvalue; track radioNode) {
  <div>
    <div class="radio-item">
      <jmkw-radio
        [id]="radioNode.key"
        [selectedId]="selectedId"
        [name]="name"
        [label]="radioNode.value.label"
        (selectChanged)="radioChangeHandler($event, radioNode)"
        >
      </jmkw-radio>
    </div>
  </div>
}
